import React from 'react';

import Input from '../forms/SearchInput';

function debounce(fn, delay) {
  let timer = null;
  return function () {
    const context = this; const
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
}

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = debounce(this.handleChange, 300);
  }

  handleChange(searchTerms) {
    const { executeSearch } = this.props;
    executeSearch(searchTerms);
    if (executeSearch) {
      executeSearch(searchTerms);
    }
  }

  render() {
    const { resetFilter, resetSearchTerm, resetAllFilter } = this.props;
    const { placeholder, resetbutton } = this.props;
    return (
      <Input type="search"
             resetSearchTerm={resetSearchTerm}
             resetAllFilter={resetAllFilter}
             resetFilter={resetFilter}
             resetbutton={resetbutton}
             placeholder={placeholder}
             onSubmit={(e) => this.handleChange(e)} />
    );
  }
}

export default Search;
